import React, { useEffect, useState } from 'react';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import { hierarchyService } from '../../services/hierarchyService';
import HierarchyDetailsModal from './HierarchyDetailsModal';

const EMPTY_DATA = { programs: [], students: [], staff: [], applications: [], departments: [], sections: [] };

const HierarchyEntityTable = ({ type, entities, onEdit, onDelete, emptyMessage }) => {
    const [selected, setSelected] = useState(null);
    const [data, setData] = useState(EMPTY_DATA);
    const [summaryError, setSummaryError] = useState('');

    useEffect(() => {
        hierarchyService.getOperationalData()
            .then(setData)
            .catch(error => {
                console.error('Failed to load hierarchy operational data:', error);
                setSummaryError(error.message || 'Summary data is unavailable');
            });
    }, []);

    if (!entities.length) return <div className="py-10 text-center text-muted-foreground">{emptyMessage}</div>;

    const parentLabel = entity => type === 'faculty' ? 'Institution' : type === 'department' ? (entity.faculty?.name || 'Faculty not assigned') : (entity.department?.name || 'Department not assigned');
    const headLabel = entity => {
        const head = entity.dean || entity.hod || entity.hos;
        return head?.full_name || head?.fullName || head?.name || head?.email || 'Not assigned';
    };

    return (
        <>
            {summaryError && <div className="mb-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">Records are available, but some operational totals could not load: {summaryError}</div>}
            <div className="overflow-x-auto rounded-lg border bg-card">
                <table className="w-full text-sm">
                    <thead className="bg-muted/50 text-left"><tr><th className="w-16 px-4 py-3">#</th><th className="px-4 py-3">{type === 'faculty' ? 'Faculty' : type === 'department' ? 'Department' : 'Section'}</th><th className="px-4 py-3">Code</th><th className="px-4 py-3">Institutional Email</th><th className="px-4 py-3">Parent</th><th className="px-4 py-3">Head</th><th className="px-4 py-3 text-right">Actions</th></tr></thead>
                    <tbody>{entities.map((entity, index) => <tr key={entity.id} className="border-t hover:bg-muted/20">
                        <td className="px-4 py-3 font-semibold text-muted-foreground">{index + 1}</td>
                        <td className="px-4 py-3"><div className="font-medium">{entity.name}</div><div className="max-w-md truncate text-xs text-muted-foreground">{entity.description || `No ${type} description`}</div></td>
                        <td className="px-4 py-3"><span className="rounded bg-muted px-2 py-1 font-mono text-xs">{entity.code}</span></td>
                        <td className="px-4 py-3 text-xs">{entity.institutional_email || 'Generated after save'}</td>
                        <td className="px-4 py-3">{parentLabel(entity)}</td>
                        <td className="px-4 py-3">{headLabel(entity)}</td>
                        <td className="px-4 py-3"><div className="flex justify-end gap-2">
                            <Button size="sm" variant="outline" onClick={() => setSelected(entity)}><Icon name="Eye" className="mr-2 h-4 w-4" />View</Button>
                            <Button size="icon" variant="ghost" onClick={() => onEdit(entity)} aria-label={`Edit ${entity.name}`}><Icon name="Edit" className="h-4 w-4" /></Button>
                            <Button size="icon" variant="ghost" className="text-muted-foreground hover:text-destructive" onClick={() => onDelete(entity.id)} aria-label={`Delete ${entity.name}`}><Icon name="Trash" className="h-4 w-4" /></Button>
                        </div></td>
                    </tr>)}</tbody>
                </table>
            </div>
            <HierarchyDetailsModal open={Boolean(selected)} onClose={() => setSelected(null)} type={type} entity={selected} data={data} />
        </>
    );
};

export default HierarchyEntityTable;
